import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { SECONDS_IN_HOUR } from './constants';

dayjs.extend(duration);

export function formatDuration(milliseconds: number, format: string): string {
  if (milliseconds < 0) return '00:00';
  return dayjs.duration(milliseconds).format(format);
}

export function formatDate(seconds: number | undefined, format: string) {
  if (seconds === undefined || !format) return undefined;
  return dayjs.unix(seconds).format(format);
}

export function millisToSec(millis: number): number;
export function millisToSec(millis: number | undefined): number | undefined {
  if (millis === undefined) return undefined;
  return millis / 1000;
}

export function secToMillis(millis: number): number;
export function secToMillis(sec: number | undefined): number | undefined {
  if (sec === undefined) return undefined;
  return sec * 1000;
}

export const durationLargestUnit = (durationInSeconds: number) => {
  if (durationInSeconds >= SECONDS_IN_HOUR) return 'hours';
  return 'minutes';
};
